var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2133 33.3137L9.30603e-05 12.1005L1.41431 10.6863L22.6275 31.8995L21.2133 33.3137Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3918 12.1005L21.1786 33.3137L19.7644 31.8995L40.9776 10.6863L42.3918 12.1005Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MyA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjIxMzMgMzMuMzEzN0w5LjMwNjAzZS0wNSAxMi4xMDA1TDEuNDE0MzEgMTAuNjg2M0wyMi42Mjc1IDMxLjg5OTVMMjEuMjEzMyAzMy4zMTM3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Mi4zOTE4IDEyLjEwMDVMMjEuMTc4NiAzMy4zMTM3TDE5Ljc2NDQgMzEuODk5NUw0MC45Nzc2IDEwLjY4NjNMNDIuMzkxOCAxMi4xMDA1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { ForwardRef as ReactComponent };